import { createContext, useContext } from "react";

export const AuthContext = createContext({
  user: null,
  checking: true,
  setUser: () => {},
});

export const useAuth = () => useContext(AuthContext);
